import {
  combineReducers,
  configureStore,
  Action,
} from '@reduxjs/toolkit'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ThunkAction } from 'redux-thunk'
import logger from 'redux-logger'

import { commonPartReducer } from './common/commonPartSlice'
import { currentReducer } from './common/currentSlice'
import { introPageReducer } from './common/introPagesSlice'
import { errorsReducer } from './common/errorsSlice'
import { loginReducer } from './auth/loginSlice'
import { memberReducer } from './member/memberSlice'
import { memberListReducer } from './member/listSlice'
import { memberTimelineReducer } from './member/timelineSlice'
import { teamListReducer } from './team/listSlice'
import { memberReportReducer } from './member/reportSlice'
import { monthlyMemberReportReducer } from './member/monthlyReportSlice'
import { customMemberReportReducer } from './member/customReportSlice'
import { dailyTeamReportReducer } from './team/dailyReportSlice'
import { monthlyTeamReportReducer } from './team/monthlyReportSlice'
import { customTeamReportReducer } from './team/customReportSlice'
import { noticeListReducer } from './notice/listSlice'
import { companyReducer } from './setting/companySlice'
import { profileReducer } from './setting/profileSlice'
import { systemReducer } from './setting/systemSlice'
import { googleSyncReducer } from './setting/googleSyncSlice'
import { microsoftSyncReducer } from './setting/microsoftSyncSlice'
import { cybozuSyncReducer } from './setting/cybozuSyncSlice'
import { managerInfoReducer } from './tutorial/managerInfoSlice'
import { contactReducer } from './contact/contactSlice'
import { exportListReducer } from './export/exportSlice'
import { searchListReducer } from './search/listSlice'
import { langStatusReducer } from './common/langStatusSlice'
import { tosAndPrivacyPolicyReducer } from './tosAndPrivacyPolicy/tosAndPrivacyPolicySlice'
import { dashboardReducer } from './dashboard/dashboardSlice'
import { importCsvReducer } from './setting/importCsvSlice'
import { modalEventListReducer } from './modalEvent/listSlice'
import { reportReducer } from './report/reportSlice'
import { summaryReducer } from './dataSummary/summarySlice'
import { analyzeReducer } from './analyze/analyzeSlice'
import { taskReducer } from './task/taskSlice'
import { informationReducer } from './information/informationSlice'
import { riskReducer } from './risk/riskSlice'
import { companyExternalApiKeyReducer } from './setting/companyExternalApiKeySlice'
import { holidayScheduleReducer } from './holidaySchedule/holidayScheduleSlice'
import { companyWeeklyTrackTimeReducer } from './setting/companyTrackTimeSlice'
import { memberWeeklyTrackTimeReducer } from './setting/memberWeeklyTrackTimeSlice'

const rootReducer = combineReducers({
  commonPart: commonPartReducer,
  current: currentReducer,
  introPage: introPageReducer,
  errors: errorsReducer,
  login: loginReducer,
  member: memberReducer,
  memberList: memberListReducer,
  teamList: teamListReducer,
  memberTimeline: memberTimelineReducer,
  dailyMemberReport: memberReportReducer,
  monthlyMemberReport: monthlyMemberReportReducer,
  customMemberReport: customMemberReportReducer,
  dailyTeamReport: dailyTeamReportReducer,
  monthlyTeamReport: monthlyTeamReportReducer,
  customTeamReport: customTeamReportReducer,
  managerInfo: managerInfoReducer,
  noticeList: noticeListReducer,
  company: companyReducer,
  profile: profileReducer,
  system: systemReducer,
  googleSync: googleSyncReducer,
  microsoftSync: microsoftSyncReducer,
  cybozuSync: cybozuSyncReducer,
  contact: contactReducer,
  export: exportListReducer,
  search: searchListReducer,
  langStatus: langStatusReducer,
  tosAndPrivacyPolicy: tosAndPrivacyPolicyReducer,
  dashboard: dashboardReducer,
  importCsv: importCsvReducer,
  modalEventList: modalEventListReducer,
  report: reportReducer,
  summary: summaryReducer,
  analyze: analyzeReducer,
  task: taskReducer,
  information: informationReducer,
  risk: riskReducer,
  companyExternalApiKey: companyExternalApiKeyReducer,
  holidaySchedule: holidayScheduleReducer,
  companyWeeklyTrackTime: companyWeeklyTrackTimeReducer,
  memberWeeklyTrackTime: memberWeeklyTrackTimeReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setupStore = () => {
  const isDevelopment = process.env.NODE_ENV !== 'production'
  let store: any = ""
  if (isDevelopment) {
    store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(logger),
      devTools: true,
    })
  } else {
    store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
      devTools: false,
    })
  }

  return store
}
